import "./Services2.module.css";
import Header from "@/reusable_sections/Header";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import ServiceCardGrid from "./sections/ServiceCardGrid";
import MaterialBreadth from "./sections/MaterialBreadth";
import HowItWorks from "./sections/HowItWorks";
import WhoTheseServicesAreFor from "./sections/WhoTheseServicesAreFor";
import ComplianceNote from "./sections/ComplianceNote";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function Services2Page() {
  return <div>
      <Header />
      <DirectAnswerBlock />
      <ServiceCardGrid />
      <MaterialBreadth />
      <HowItWorks />
      <WhoTheseServicesAreFor />
      <ComplianceNote />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}